import "./updatePendingTicketLocalTime.scss";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";
import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import useFetch from "../../../hooks/useFetch";
import newRequest from "../../../context/newRequest";
import {formatDate, sleep} from "../../../helper/helper";

const UpdatePendingTicketLocalTime = ({ title }) => {
    const [ticketInfo, setticketInfo] = useState({});
    const [sending, setSending] = useState("");
    const { ticketId } = useParams();
    const user = localStorage.getItem("user");
    const { data, loading, error } = useFetch(`/ticketsite/${ticketId}`);
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        start_pending1: "",
        start_pending2: "",
        end_pending1: "",
        end_pending2: "",
    });

    useEffect(() => {
        setticketInfo(data);
    }, [data]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };




    const dateTicket = () => {
        const dateStart_Pending =  formatDate(ticketInfo.start_pending);
        const dateStart_Pending2 =  formatDate(ticketInfo.start_pending2);
        const dateEnd_Pending =  formatDate(ticketInfo.end_pending);
        const dateEnd_Pending2 =  formatDate(ticketInfo.end_pending2);

        const date = {
            Start_Pending : dateStart_Pending,
            Start_Pending2: dateStart_Pending2,
            End_Pending : dateEnd_Pending,
            End_Pending2 : dateEnd_Pending2,

        }
        return date;
    }
    const date = dateTicket()



    const handleClick = async (e) => {
        e.preventDefault();
        setSending("On Submit")
        try {
            setSending("Mengirim Data")
            setSending("Mengirim Data")
            const start_pending1_Millis = new Date(formData.start_pending1).getTime();
            const start_pending2_Millis = new Date(formData.start_pending2).getTime();
            const End_pending1_Millis = new Date(formData.end_pending1).getTime();
            const End_pending2_Millis = new Date(formData.end_pending2).getTime();

            const newTicketUpdate = {
                start_pending: start_pending1_Millis,
                start_pending2: start_pending2_Millis,
                end_pending: End_pending1_Millis,
                end_pending2: End_pending2_Millis,

            };


            const res= await newRequest.put(`/ticketlocal/pending/${ticketId}`, newTicketUpdate, {
                // headers
                headers: {
                    'Authorization': `$Bearer ${user.token}`
                },
            });
            if (res.status == 200) {
                await sleep(2000)
                setSending("Berhasil Mengirim Data")
                navigate(`/ticketsite/${ticketId}`);
            }
            console.log(res.status)
        } catch (err) {
            setSending(err.response.data.errors)
            console.log(err);
        }
    };
    console.log(ticketInfo)
    return (
        <div className="new">
            <Sidebar />
            <div className="newContainer">
                <Navbar/>
                <div className="top">
                    <h1>{title}</h1>
                </div>
                <div className="bottom">
                    <div className="right">
                        <div className="detailItem">
                            <span className="itemKey">Ticket ID:</span>
                            <span className="itemValue">{ticketId}</span>
                        </div>
                        <div className="detailItem">
                            <span className="itemKey">Site Customer:</span>
                            <span className="itemValue">
                        {ticketInfo.customer_site}
                  </span>
                        </div>
                        <div className="detailItem">
                            <span className="itemKey">Start Pending:</span>
                            <span className="itemValue">{date.Start_Pending}</span>
                        </div>

                        <div className="detailItem">
                            <span className="itemKey">End Pending :</span>
                            <span className="itemValue">{date.End_Pending}</span>
                        </div>
                        <br/>
                        <br/>

                        <div className="detailItem">
                            <span className="itemKey">Start Pending 2:</span>
                            <span className="itemValue">{date.Start_Pending2}</span>
                        </div>

                        <div className="detailItem">
                            <span className="itemKey">End Pending 2:</span>
                            <span className="itemValue">{date.End_Pending2}</span>
                        </div>
                        <form>
                            <div className="formInput">
                                <div>
                                    <label>Start Pending 1:</label>
                                    <input
                                        type="datetime-local"
                                        name="start_pending1"
                                        value={formData.start_pending}
                                        onChange={handleChange}
                                    />
                                </div>


                                <div>
                                    <label>End Pending 1:</label>
                                    <input
                                        type="datetime-local"
                                        name="end_pending1"
                                        value={formData.end_pending}
                                        onChange={handleChange}
                                    />
                                </div>
                                <br/>
                                <br/>
                                <div>
                                    <label>Start Pending 2:</label>
                                    <input
                                        type="datetime-local"
                                        name="start_pending2"
                                        value={formData.start_pending2}
                                        onChange={handleChange}
                                    />
                                </div>
                                <div>
                                    <label>End Pending 2:</label>
                                    <input
                                        type="datetime-local"
                                        name="end_pending2"
                                        value={formData.end_pending2}
                                        onChange={handleChange}
                                    />
                                </div>
                                <button onClick={handleClick}>Send</button>
                            </div>
                        </form>
                    </div>
                </div>
                {sending && <p className="error">{sending}</p>}
                <br/>
                <br/>
                <br/>
                <br/>

            </div>
        </div>
    );
};

export default UpdatePendingTicketLocalTime;
